<template>
  <div style="padding:20px;width:100vw;min-width:900px">
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3 mr-r15">MIB 브라우저</div>
      </div>
      <div class="vertical-center-box">
        <el-select v-model="agentManagerId">
          <el-option v-for="item in agentMgrList" :key="item.agentManagerId" :label="item.agentManagerIpaddress" :value="item.agentManagerId"></el-option>
        </el-select>
      </div>
    </el-row>
    <w-mib-browser-panel :agent-manager-id="agentManagerId"></w-mib-browser-panel>
  </div>
</template>

<script>
import { isNil } from 'lodash';
import IpScanAPI from '@/api/ip-scan';
import WMibBrowserPanel from './components/MibBrowserPanel';

export default {
  name: 'WMibBrowser',
  components: {
    WMibBrowserPanel,
  },
  data() {
    return {
      agentMgrList: [],
      agentManagerId: 0,
    };
  },
  created() {
    this.$store.dispatch('openFullScreenLayer');
    document.body.className += ' mib_popup ';
  },
  mounted() {
    IpScanAPI.getAgentMgrList().then((response) => {
      const result = response.data;
      if (result.success) {
        this.agentMgrList = result.data;
        const objId = this.$route.params.objId;
        if (!isNil(objId)) {
          IpScanAPI.getAgentManagerIdByObjId(objId).then((res) => {
            const subResult = res.data;
            if (subResult.success) {
              const agentManagerId = subResult.data;
              this.agentManagerId = agentManagerId;
            }
          });
        }
      }
    });
  },
  methods: {
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/popup/MibBrowser/index.vue